import { UserRoleEnum } from '@/types/graphql';

type AdminLike = { user?: { roleId?: UserRoleEnum | null } | null } | null;

// Who the signed-in admin is comes from `user.roleId`, the field PrivateRoute
// and graphy's `require_tenant_admin_role` use. Never compare `currentAdmin.role`
// with `Role` from PrivateRoute: `role` is graphy's TenantRole/CustomerRole
// LEVEL (MANAGER 0, ANALYST 1, ADMIN 2), so `role === Role.TENANT_ADMIN` (1)
// matched only ANALYST-level admins. That shut out default ADMIN-level tenant
// admins and let in helpdesk admins, whom TenantAdminInvite creates at ANALYST.
// Likewise `role === Role.CUSTOMER_ADMIN` (0) matched every MANAGER-level
// admin, tenant or client, and missed ANALYST/ADMIN-level client admins.

// TENANT_ADMIN users only. Helpdesk admins are excluded.
export const isTenantAdminUser = (admin: AdminLike | undefined): boolean =>
  admin?.user?.roleId === UserRoleEnum.TENANT_ADMIN;

// GravyWork staff (tenant or helpdesk admins), as opposed to client admins.
// Use this where the other branch assumes a client admin: client navigation,
// `currentAdmin.customer`, or client-only notices.
export const isStaffAdminUser = (admin: AdminLike | undefined): boolean =>
  admin?.user?.roleId === UserRoleEnum.TENANT_ADMIN ||
  admin?.user?.roleId === UserRoleEnum.HELPDESK_ADMIN;

// Client (customer) admins only, at any CustomerRole level.
export const isClientAdminUser = (admin: AdminLike | undefined): boolean =>
  admin?.user?.roleId === UserRoleEnum.CUSTOMER_ADMIN;
